<template>
  <v-layout class="d-flex align-self-center justify-center pt-0">
    <v-flex xs10 sm10 md10 lg6>
      <v-row class="align-center justify-center ma-0 mt-12">
        <v-card
          elevation="5"
          style="border-radius: 6px !important;"
          height="200"
          class="d-flex justify-center"
        >
          <v-row no-gutters class="justify-center">
            <v-col lg="6">
              <p
                class="pt-8 px-4 title font-weight-bold text-center"
              >A loja de qual empresa você gostaria de acessar?</p>
            </v-col>
            <v-col lg="10" class="d-flex align-end">
              <v-select
                v-model="empresaSelecionada"
                :items="empresas"
                name="empresa"
                item-text="empStrNme"
                return-object
                label="Selecione uma empresa"
                color="var(--vs-azul-secundaria)"
                @change="direcionamento"
                class="px-4"
              ></v-select>
            </v-col>
          </v-row>
        </v-card>
      </v-row>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "home",
  data: () => ({
    empresaSelecionada: null
  }),

  computed: {
    ...mapState({
      showError: state => state.core.error !== null && state.core.error !== "",
      user: state => state.cliente.user,
      loading: state => state.core.loading
    }),
    ...mapGetters({
      empresas: "empresa/empresas"
    })
  },
  methods: {
    direcionamento() {
      // console.log(this.empresaSelecionada.empIntCod);
      this.$route.params.id = this.empresaSelecionada.empIntCod;
      this.$store.dispatch("anuncio/carregarEmpresa", this.$route.params.id);
      this.$router.push({ name: "login" });
    }
  },
  mounted() {
    this.$store.dispatch("empresa/carregarEmpresas");
  }
};
</script>
